import axios from "axios";


export default {


    addCorteCaja() {
        const tokenAuth = localStorage.getItem("access_token");
        const headerAuth = {
            headers: {
                Authorization: `${tokenAuth}`
            }
        };

        return axios
            .post("api/corte-caja/agregar", null, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    verificarCaja(sucursalId) {

        const tokenAuth = localStorage.getItem("access_token");
        const headerAuth = {
            headers: {
                Authorization: `${tokenAuth}`
            }
        };

        return axios
            .get(`api/verificar-caja/${sucursalId}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    realizarCorteCaja(corteCaja) {

        const tokenAuth = localStorage.getItem("access_token");
        const headerAuth = {
            headers: {
                Authorization: `${tokenAuth}`
            }
        };

        return axios
            .post(`api/corte-caja/realizar`, corteCaja, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getCorteCajaTicket(bitacoraTicketId = 0) {

        const tokenAuth = localStorage.getItem("access_token");
        const headerAuth = {
            headers: {
                Authorization: `${tokenAuth}`
            }
        };

        return axios
            .get(`api/corte-caja/ticket/${bitacoraTicketId}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
    async getCortesCaja(filtros) {
        let tokenAuth = localStorage.getItem("access_token");
        let config = {
            headers: { Authorization: `${tokenAuth}` },
            params: filtros,
        };

        try {
            const result = await axios.get(`api/corte-caja/cortes/`, config);
            return result.data;
        } catch (e) {
            console.log(e);
            throw e;
        }
    },
};